function App() {
  return (
    <iframe
      src="/landing.html"
      style={{ width: '100%', height: '100vh', border: 'none' }}
      title="landing"
    />
  )
}

export default App
